<template>
  <div class="serviceDetail">
    <!--面包屑-->
    <div class="navSecond">
      <b><a class="el-icon-arrow-left"></a>&nbsp;<a @click="goBack">返回</a>&nbsp;&nbsp; |&nbsp;&nbsp;</b>
      <span>服务详情</span>
      <div class="buttonBox">
        <button :disabled="!previewBtnShow || !uploadSucceedFlag" :class="{'popGrayBtn': (!previewBtnShow && !uploadSucceedFlag) || (!previewBtnShow || !uploadSucceedFlag), 'previewBtn': previewBtnShow && uploadSucceedFlag}" @click="goServicePreviewFun">预览</button>
        <button :disabled="!previewBtnShow || !uploadSucceedFlag" :class="{'popGrayBtn': (!previewBtnShow && !uploadSucceedFlag) || (!previewBtnShow || !uploadSucceedFlag), 'orangeLineBtn': previewBtnShow && uploadSucceedFlag}" @click="saveServerDetail(1)" style="margin: 0 8px;">保存并继续</button>
        <button :disabled="!previewBtnShow || !uploadSucceedFlag" :class="{'popGrayBtn': (!previewBtnShow && !uploadSucceedFlag) || (!previewBtnShow || !uploadSucceedFlag), 'orangeBtn': previewBtnShow && uploadSucceedFlag}" @click="saveServerDetail(2)">发布</button>
      </div>
    </div>
    <div class="serviceDetailMain">
      <div class="serviceIphoneMain">
        <div class="iPhoneTitleImg"></div>
        <div>
          <el-upload action="a" list-type="picture-card" :http-request="UploadFile" :file-list="fileList"
                     :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
            <div><i class="el-icon-plus"></i><span>添加图片</span></div>
            <div class="suggestTest">建议宽度750像素</div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </div>
        <!--左下角提示文字-->
        <span class="serviceIphoneHint">iPhone8手机高度</span>
      </div>
    </div>
    <!--预览弹窗-->
    <div class="popBackground" v-show="previewPopShow">
      <div class="previewPopCon">
        <span class="previewServerDet">服务详情</span>
        <div class="QRCode">
          <div class="QRCodeTitle">扫码查看手机效果</div>
          <div class="QRCodePic">
            <img :src="QRCodeImg"/>
          </div>
        </div>
        <div class="phonePreview">
          <div class="phonePreviewContent">
            <div class="phoneCon" v-for="item in this.servicePreviewList">
              <img :src="item">
            </div>
          </div>
        </div>
        <div class="close">
          <img src="../../assets/image/icon/preview_icon_delete.png" @click="closePreviewPop" alt="">
        </div>
      </div>
    </div>
    <!--成功提示-->
    <div class="operationSuccessTip" v-show="succeedHintPop">
      <i></i><span>{{succeedHintText}}</span>
    </div>
    <!--未保存返回提示弹窗-->
    <div class="popBackground" v-show="leaveTipPop">
      <div class="popContent deletePopCon">
        <div class="popContentTop deletePopConTop">
          <img src="../../assets/image/icon/window_icon_prompt.png" />
          <b>详情尚未保存，确定要离开当前页面吗？</b>
        </div>
        <div class="popFooter">
          <button class="popWhiteBtn" @click="leavePage">离开页面</button>
          <button class="orangeBtn" @click="()=>{this.leaveTipPop = false;}" style="margin-left: 8px;">留在页面</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {originconfig} from "../../../static/apiConfig/originConfig";
    export default {
      name: "serviceDetail",
      data(){
        return{
          dialogImageUrl: '',
          dialogVisible: false,
          uploadImgText:'',
          uploadImgText1:'',
          fileList:[],
          succeedHintPop:false,
          succeedHintText:'',
          previewPopShow:false,
          servicePreviewList:[],
          servicePreviewList1:[],
          previewBtnShow:false,
          QRCodeImg:'',
          previewContentPics:'',
          uploadImgFlag:0,
          operateFlag:0,
          leaveTipPop:false,
          removeServerDetailImgFlag:0,
          serverDetailImgDelFlag:'',
          imgDelNextStepFlag:0,
          uploadSucceedFlag:true,
        }
      },
      watch:{
        servicePreviewList:{
          handler:function(n,o){
            if(n && n.length !== 0){
              this.previewBtnShow = true;
            }else{
              this.previewBtnShow = false;
            }
          },
          deep:true
        },
        fileList:{
          handler:function(n,o){
            if(n && n.length !== 0){
              this.previewBtnShow = true;
            }else{
              this.previewBtnShow = false;
            }
          },
          deep: true
        }
      },
      mounted(){
        this.serverId = JSON.parse(sessionStorage.getItem('serverId'));
        this.getServiceDetail();
      },
      methods:{
        goBack(){
          if(this.operateFlag === 0 && this.uploadImgFlag === 1){ //没有点击过右上角三个按钮（没有保存到后台），但是上传过文件
            this.leaveTipPop = true;
          }else{
            this.$router.push({name:'serviceManage'})
          }
        },
        leavePage(){
          this.$router.push({name:'serviceManage'})
        },
        getServiceDetail(){
          this.$post('/server/get',{serverId: this.serverId,isXcX: 0}).then((data)=>{
            this.servicePreviewList = [];
            this.servicePreviewList1 = [];
            this.previewContentPicsList = [];
            this.fileList = [];
            this.previewContentPics = data.data.previewContentPics;
            if(this.previewContentPics && this.previewContentPics !== ''){
              this.previewContentPicsList = data.data.previewContentPics.split(',');
              this.previewContentPicsList.forEach(s=>{
                this.fileList.push({name:s,url: originconfig.domain + s});
                this.servicePreviewList.push(originconfig.domain + s);
                this.servicePreviewList1.push(s);
              })
            }
          })
        },
        //上传文件
        UploadFile(content) {//上传文件
          this.uploadSucceedFlag = false;
          let msg = new FormData();
          msg.append('file', content.file);
          msg.append('enctype', 'multipart/form-data');
          this.$post('/server/picture/upload', msg, {
            headers: {'Content-Type': 'multipart/form-data'},
            // fileType: 'text'  //上传文件类型设置
          }).then(data => {
            let variable = data.data;
            this.uploadImgText1 += variable + ',';
            this.uploadImgText  = '';
            if(this.previewContentPics && this.previewContentPics !== '' && this.previewContentPics !== undefined && this.previewContentPics !== null){
              this.uploadImgText = this.previewContentPics + ',' + this.uploadImgText1;
            }else{
              this.uploadImgText = this.uploadImgText1;
            }
            this.previewBtnShow = true;
            this.servicePreviewList.push(originconfig.domain + data.data);
            this.servicePreviewList1.push(data.data);
            this.uploadImgFlag = 1;
            this.uploadSucceedFlag = true;
            // console.log(this.uploadImgText.substring(0, this.uploadImgText.lastIndexOf(',')))
          })
        },
        handleRemove(file, fileList) {
          this.removeServerDetailImgFlag = 1;
          this.serverDetailImgDelFlag += file.name + ',';
          if(fileList.length !== 0){
            this.previewBtnShow = true;
          }else{
            this.previewBtnShow = false;
          }
        },
        handlePictureCardPreview(file) {
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        },
        //服务详情图片删除接口的封装，与下面用的删除是一样的
        serverDetailImgDel(){
          if(this.serverDetailImgDelFlag !== '' && this.serverDetailImgDelFlag !== undefined && this.serverDetailImgDelFlag !== null){
            this.$post('/delete/pic/file',{picUrl:this.serverDetailImgDelFlag}).then((data)=>{
              if(data.errorCode === 0){
                this.serverDetailImgDelFlag1 = this.serverDetailImgDelFlag.substring(0, this.serverDetailImgDelFlag.lastIndexOf(','))
                this.serverDetailImgDelFlagList = this.serverDetailImgDelFlag1.split(',');
                this.serverDetailImgDelFlagList.forEach(s=>{
                  this.fileList.forEach((f,k)=>{
                    if(f.url === originconfig.domain + s){
                      this.fileList.splice(k,1);
                    }
                  })
                  this.servicePreviewList.forEach((e,k)=>{
                    if(e === originconfig.domain + s){
                      this.servicePreviewList.splice(k,1);
                    }
                  })
                })
                this.uploadImgText = this.servicePreviewList.toString() + ',';
                this.imgDelNextStepFlag = 1;
              }
            })
          }
        },
      //  保存及发布
        saveServerDetail(type) {
          if(type === 1){ //保存并继续
            if(this.serverDetailImgDelFlag !== '' && this.serverDetailImgDelFlag !== undefined && this.serverDetailImgDelFlag !== null){
              this.serverDetailImgDelFlag1 = this.serverDetailImgDelFlag.substring(0, this.serverDetailImgDelFlag.lastIndexOf(','))
              this.serverDetailImgDelFlagList = this.serverDetailImgDelFlag1.split(',')
              this.serverDetailImgDelFlagList.forEach(s=>{
                this.fileList.forEach((f,k)=>{
                  if(f.url === originconfig.domain + s){
                    this.fileList.splice(k,1);
                  }
                })
                this.servicePreviewList1.forEach((e,k)=>{
                  if(e === s){
                    this.servicePreviewList1.splice(k,1);
                  }
                })
              })
              this.uploadImgText = this.servicePreviewList1.toString() + ',';
              this.imgDelNextStepFlag = 1;
            }
            this.params = {
              serverId: this.serverId,
              previewContentPics: this.uploadImgText ? this.uploadImgText.substring(0, this.uploadImgText.lastIndexOf(',')) : '-',
            }
            this.$post('/server/update',this.params).then((data)=>{
              if(data.errorCode == 0){
                  this.operateFlag = 1;
                  this.succeedHintPop = true;
                  this.succeedHintText = '保存成功';
                  let _this = this;
                  setTimeout(function () {
                    _this.succeedHintPop = false;
                  },1500)
                this.getServiceDetail();
              }
            })
          }else if(type === 2){  //发布
            if(this.serverDetailImgDelFlag !== '' && this.serverDetailImgDelFlag !== undefined && this.serverDetailImgDelFlag !== null){
              this.$post('/delete/pic/file',{picUrl:this.serverDetailImgDelFlag}).then((data)=>{
                if(data.errorCode === 0){
                  this.serverDetailImgDelFlag1 = this.serverDetailImgDelFlag.substring(0, this.serverDetailImgDelFlag.lastIndexOf(','))
                  this.serverDetailImgDelFlagList = this.serverDetailImgDelFlag1.split(',')
                  this.serverDetailImgDelFlagList.forEach(s=>{
                    this.fileList.forEach((f,k)=>{
                      if(f.url === originconfig.domain + s){
                        this.fileList.splice(k,1);
                      }
                    })
                    this.servicePreviewList1.forEach((e,k)=>{
                      if(e === s){
                        this.servicePreviewList1.splice(k,1);
                      }
                    })
                  })
                  this.uploadImgText = this.servicePreviewList1.toString() + ',';
                  this.imgDelNextStepFlag = 1;
                  this.params = {
                    serverId: this.serverId,
                    serverContentPics: this.uploadImgText ? this.uploadImgText.substring(0, this.uploadImgText.lastIndexOf(',')) : '-',
                  }
                  this.$post('/server/update',this.params).then((data)=>{
                    if(data.errorCode == 0){
                      if(type === 1){  //保存并继续
                        this.operateFlag = 1;
                        this.succeedHintPop = true;
                        this.succeedHintText = '保存成功';
                        let _this = this;
                        setTimeout(function () {
                          _this.succeedHintPop = false;
                        },1500)
                      }else if(type === 2){ //发布
                        this.operateFlag = 1;
                        this.succeedHintPop = true;
                        this.succeedHintText = '发布成功';
                        let _this = this;
                        setTimeout(function () {
                          _this.succeedHintPop = false;
                          _this.$router.push({name:'serviceManage'});
                        },1500)
                      }
                      this.getServiceDetail();
                    }
                  })
                }
              })
            }else{
              if(this.removeServerDetailImgFlag === 0 && this.uploadImgFlag === 0){  //没有删除图片直接操作预览按钮时需要加上列表中之前预览或者存储的img
                if(this.previewContentPics && this.previewContentPics !== '' && this.previewContentPics !== undefined && this.previewContentPics !== null){
                  this.uploadImgText = this.previewContentPics + ',';
                }
              }
              this.params = {
                serverId: this.serverId,
                serverContentPics: this.uploadImgText ? this.uploadImgText.substring(0, this.uploadImgText.lastIndexOf(',')) : '-',
              }
              this.$post('/server/update',this.params).then((data)=>{
                if(data.errorCode == 0){
                  this.operateFlag = 1;
                  this.succeedHintPop = true;
                  this.succeedHintText = '发布成功';
                  let _this = this;
                  setTimeout(function () {
                    _this.succeedHintPop = false;
                    _this.$router.push({name:'serviceManage'});
                  },1500)
                  this.getServiceDetail();
                }
              })
            }
            this.params = {
              serverId: this.serverId,
              serverContentPics: this.uploadImgText ? this.uploadImgText.substring(0, this.uploadImgText.lastIndexOf(',')) : '-',
            }
          }
        },
      //  预览弹窗
        goServicePreviewFun(){
          if(this.serverDetailImgDelFlag !== '' && this.serverDetailImgDelFlag !== undefined && this.serverDetailImgDelFlag !== null){
            this.$post('/delete/pic/file',{picUrl:this.serverDetailImgDelFlag}).then((data)=>{
              if(data.errorCode === 0){
                this.serverDetailImgDelFlag1 = this.serverDetailImgDelFlag.substring(0, this.serverDetailImgDelFlag.lastIndexOf(','))
                this.serverDetailImgDelFlagList = this.serverDetailImgDelFlag1.split(',')
                this.serverDetailImgDelFlagList.forEach(s=>{
                  //预览的图片数组
                  this.servicePreviewList.forEach((e,k)=>{
                    if(e === originconfig.domain + s){
                      this.servicePreviewList.splice(k,1);
                    }
                  })
                  this.fileList.forEach((f,k)=>{
                    if(f.url === originconfig.domain + s){
                      this.fileList.splice(k,1);
                    }
                  })
                  this.servicePreviewList1.forEach((e,k)=>{
                    if(e === s){
                      this.servicePreviewList1.splice(k,1);
                    }
                  })
                })
                this.uploadImgText = this.servicePreviewList1.toString() + ',';
                this.imgDelNextStepFlag = 1;
                //预览
                if(this.removeServerDetailImgFlag === 0){  //没有删除图片直接操作预览按钮时需要加上列表中之前预览或者存储的img
                  if(this.previewContentPics && this.previewContentPics !== '' && this.previewContentPics !== undefined && this.previewContentPics !== null){
                    this.uploadImgText = this.previewContentPics + ',' + this.uploadImgText;
                  }
                }
                let params = {
                  serverId: this.serverId,
                  previewContentPics: this.uploadImgText ? this.uploadImgText.substring(0, this.uploadImgText.lastIndexOf(',')) : '',
                }
                this.$post('/server/preview',params).then((data)=>{
                  if(data.errorCode === 0){
                    this.operateFlag = 1;
                    this.QRCodeImg = originconfig.domain + data.data;
                  }
                });
                this.previewPopShow = true;
              }
            })
          }else{
            //预览
            if(this.removeServerDetailImgFlag === 0 && this.uploadImgFlag === 0){  //没有删除图片直接操作预览按钮时需要加上列表中之前预览或者存储的img
              if(this.previewContentPics && this.previewContentPics !== '' && this.previewContentPics !== undefined && this.previewContentPics !== null){
                this.uploadImgText = this.previewContentPics + ',';
              }
            }
            let params = {
              serverId: this.serverId,
              previewContentPics: this.uploadImgText ? this.uploadImgText.substring(0, this.uploadImgText.lastIndexOf(',')) : '',
            }
            this.$post('/server/preview',params).then((data)=>{
              if(data.errorCode === 0){
                this.operateFlag = 1;
                this.QRCodeImg = originconfig.domain + data.data;
              }
            });
            this.previewPopShow = true;
          }
        },
        closePreviewPop(){
          this.previewPopShow = false;
        },
      }
    }
</script>

<style lang="scss">
  .serviceDetail{
    .el-upload--picture-card{
      width: 100%;
      height: 100px;
      line-height: 30px;
      -webkit-border-radius: 1px;
      -moz-border-radius: 1px;
      border-radius: 1px;
      color: #007AFF;
      padding-top: 27px;
      div{
        width: 100%;
        height: 30px;
        line-height: 30px;
      }
      .suggestTest{
        color: #788EEB;
      }
      i{
        font-size: 14px;
        font-weight: 600;
        margin-right: 5px;
        color: #007AFF;
      }
    }
    .el-upload-list--picture-card{
      width: 100%;
      height: 100%;
      font-size: 0px;
      .el-upload-list__item{
        width: 100%;
        height: auto;
        margin: 0;
        padding: 0;
        display: block;
        border-radius: 0;
        font-size: 14px;
        border: none;
        line-height: 1;
      }
    }
    .el-upload-list--picture-card .el-upload-list__item-thumbnail{
      display: block;
    }
    /*.el-upload-list__item.is-success .el-upload-list__item-status-label{*/
      /*display: none;*/
    /*}*/
    /*.el-icon-zoom-in, .el-icon-delete{*/
      /*display: none;*/
    /*}*/
  }
</style>
<style scoped lang="scss">
  .serviceDetail{
    width: 100%;
    height: 100%;
    background:rgba(240,242,245,1);
    .uploadFlagDisabled{
      cursor: not-allowed;
    }
    .serviceDetailMain{
      height: calc(100% - 56px);
      overflow: auto;
      .serviceIphoneMain{
        width:375px;
        min-height:667px;
        background:rgba(244,244,244,1);
        box-shadow:0px 0px 8px 0px rgba(51,51,51,0.1);
        margin: 24px auto;
        position: relative;
        .iPhoneTitleImg{
          height: 65px;
          background: url("../../assets/image/contentManagement/top.png");
        }
        .serviceIphoneHint{
          height: 18px;
          color: #999999;
          padding: 0 20px 5px 0;
          border-bottom: solid 1px #CCCCCC;
          position: absolute;
          left: -131px;
          top: 644px;
        }
      }
    }
    .previewPopCon{
      width: 334px;
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      .previewServerDet{
        position: absolute;
        top: 95px;
        left: 136px;
        color: #333;
      }
      .QRCode{
        width:128px;
        height:156px;
        background:rgba(255,255,255,1);
        border-radius:4px;
        padding: 24px;
        position: absolute;
        left: -216px;
        top: 73px;
        .QRCodeTitle{
          color: #FF6215;
          font-weight: 600;
          text-align: center;
        }
        .QRCodePic{
          height: calc(100% - 32px);
          margin-top: 12px;
          img{
            width: 100%;
            height: 100%;
          }
        }
      }
      .phonePreview{
        width:284px;
        height:454px;
        /*margin-left: 40px;*/
        /*margin-right: 10px;*/
        border-radius:4px;
        padding: 122px 25px 74px;
        background: url("../../assets/image/contentManagement/img_iPhone.png") 100% 100%;
        .phonePreviewContent{
          height: 100%;
          overflow-y: auto;
          background: #fff;
          img{
            max-width: 100% !important;
            display: block;
          }
        }
      }
      .close{
        position: absolute;
        right: -42px;
        top: 0;
        img{
          width: 32px;
          height: 32px;
          border-radius: 16px;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/contentManagement/serviceDetail.vue